// extracted by mini-css-extract-plugin
export default {"container":"index_container_IQZ","retryBtn":"index_retryBtn_eKP","ldsSpinner":"index_ldsSpinner_NAs","lds":"index_lds_O1s"};